import script from "./promotionTimeControl.vue?vue&type=script&lang=ts&setup=true"
export * from "./promotionTimeControl.vue?vue&type=script&lang=ts&setup=true"

import "./promotionTimeControl.vue?vue&type=style&index=0&id=4139690a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4139690a"]])

export default __exports__